import { IconQuestion, Tooltip } from '@leland-dev/leland-ui-library';
import React, { type ReactElement, type SVGProps } from 'react';

interface InfoWithIconProps {
  Icon: React.FC<SVGProps<SVGSVGElement>>;
  text: string | ReactElement;
  className?: string;
  small?: boolean;
  large?: boolean;
  tooltip?: string;
}

const InfoWithIcon: React.FC<InfoWithIconProps> = ({
  Icon,
  text,
  className = '',
  small,
  large,
  tooltip,
}) => {
  return (
    <div
      className={`flex items-center space-x-3 text-leland-gray-light ${className}`}
    >
      <Icon className="size-5 shrink-0" />
      <div
        className={`${small ? 'text-sm' : large ? 'text-lg' : ''} leading-none`}
      >
        {text}
      </div>
      {tooltip ? (
        <Tooltip content={tooltip}>
          <IconQuestion className={small ? 'size-3.5' : 'size-4'} />
        </Tooltip>
      ) : null}
    </div>
  );
};

export default InfoWithIcon;
